export const NOT_PROVIDED = "HR-ben nincs megadva";
export const DOTTED_LINE = ".........................................";
